import { Component, OnInit } from '@angular/core';
import { CommonService } from '../service/common.service';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { Ruolo } from '../models/ruolo';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-registrazione',
  templateUrl: './registrazione.component.html',
  styleUrls: ['./registrazione.component.css']
})
export class RegistrazioneComponent implements OnInit {
  user: User=new User();
  hide = true;
  selectedRole:string='';
  ruoli: Ruolo[];
  rc:number;
  usertoedit: boolean;
  IPAddress:string;
  Port:string;
  Protocol:string;
  //pwd:string='';
  //confermaPwd:string='';

  selectedFile: File;
  retrievedImage: any;
  base64Data: any;
  retrieveResonse: any;
  imageName: any;
  registerForm: FormGroup;
  submitted = false;
  imagehaschanged=false;

  public message =  sessionStorage.getItem('token');

  constructor(private httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder) {
      if (environment.address.isLocal){
        this.IPAddress=environment.address.localIP;
        this.Port=environment.address.localPort;
        this.Protocol=environment.address.localProtocol;
      }else{
        this.IPAddress=environment.address.remoteIP;
        this.Port=environment.address.remotePort;
        this.Protocol=environment.address.remoteProtocol;
      }

    }

  ngOnInit(): void {
    if (this.registerForm===undefined){
    this.registerForm = this.formBuilder.group({
            Firstname: [''],
            Lastname: [''],
            Email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
            Password: ['', [Validators.required, Validators.minLength(8)]],
            confermaPwd: ['', [Validators.required, Validators.minLength(8)]],
            Cellulare: [''],
            Liberatoria: [''],
            checkLiberatoria: [false]
//            Language: [''],
//            Birthdate: [''],
//            Birthcity: [''],
//            Nationality: [''],
//            Birthprovince: [''],
//            Firstname: [''],
//            Lastname: [''],
//            Fiscalcode: [''],
//            City: [''],
//            Province: [''],
//            Residence: [''],
//            Zipcode: [''],
//            Phone: [''],
        });
    }

  }
get f() { return this.registerForm.controls; }

save() {
        this.submitted = true;
        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else{
            this.commonService.registrazione(this.registerForm.value).subscribe(data => {
              this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
      //        console.log("--->SaveUser"+this.rc.toString());
              if (this.rc>0){
                alert("Utente creato con successo");
              }else if (this.rc===-1){
                alert("Errore creazione utente");
              }else if (this.rc===-2){
                alert("Lo Username è di un utente esistente");
              }
            });
        }
    //    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value))
    }

  updateLiberatoria(checked: boolean, index?: number) {
    if (checked){ 
      this.registerForm.patchValue({ Liberatoria: "YES" });
    } else {
      this.registerForm.patchValue({ Liberatoria: "NO" });  
    }
  }
  tec(){
    window.open('assets/tec.html', '_blank', 'width=500,height=400');
  }
  cancel(){
    this.commonService.selectedUser=null;
    this.router.navigate(['users']);
  }



}
